export default () => (
<svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 1V3.47998C4 4.41331 3.56802 5.29327 2.82402 5.77327L1 7" stroke="#161B2D" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
)